document.addEventListener('click', function (e) {
  const button = e.target.closest('[data-add-to-cart-grid]');
  if (!button) return;

  e.preventDefault();

  const form = button.closest('form');
  if (!form) return;

  const formData = new FormData(form);

  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(response => response.json())
    .then(product => {
      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: button
          }
        })
      );
    })
    .catch(error => {
      console.error('Add to cart error:', error);
    });
});